/**
 * @generated SignedSource<<eab722f64a7a96a063a9ddddfe81f8fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FlightUpdateInput = {
  expired?: boolean | null;
};
export type FlightEditGeneralInfoFormMutation$variables = {
  id: string;
  input: FlightUpdateInput;
};
export type FlightEditGeneralInfoFormMutation$data = {
  readonly updateFlight: {
    readonly expired: boolean;
  };
};
export type FlightEditGeneralInfoFormMutation = {
  response: FlightEditGeneralInfoFormMutation$data;
  variables: FlightEditGeneralInfoFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expired",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FlightEditGeneralInfoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "updateFlight",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FlightEditGeneralInfoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "updateFlight",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ecf5f90d8739bba9b18e39b53de2b81",
    "id": null,
    "metadata": {},
    "name": "FlightEditGeneralInfoFormMutation",
    "operationKind": "mutation",
    "text": "mutation FlightEditGeneralInfoFormMutation(\n  $id: ID!\n  $input: FlightUpdateInput!\n) {\n  updateFlight(id: $id, input: $input) {\n    expired\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c149fc12ec20d583499b495526d834b9";

export default node;
